<template>
    <div class="Settle">
        <div class="left">
           <div class="logo">
               <img src=""/>
           </div>
           <div class="text">
               <p>商家账号注册</p>
               <p>信服到家</p>
           </div>
           <p class="login">
              已有账号？
              <span class="link"  @click="$router.push('/login')">去登录</span>
              <!-- <el-link class="link" type="danger">去登录</el-link> -->
           </p>
        </div>
        <div class="right">
            <div class="steps">
              <p><span><i class="el-icon-check"></i></span>填写账号信息</p><span class="lin"></span>
              <p><span class="in">2</span>填写企业信息</p><span class="lin"></span>
              <p><span>3</span>审核</p>
            </div>
            <div class="main">
                <div class="title">填写企业信息</div>
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="demo-ruleForm from">
                    <el-form-item label="公司名称:" prop="name">
                        <el-input style="width:60%" v-model="ruleForm.name"  placeholder="请输入公司名称"></el-input>
                    </el-form-item>
                    <el-form-item label="公司所在地:" prop="address">
                      <el-cascader  v-model="ruleForm.address" placeholder="请选择公司所在地"  :options="options" ></el-cascader>
                    </el-form-item>
                     <el-form-item label="详细地址:" prop="addressDetail">
                        <el-input  style="width:60%" v-model="ruleForm.addressDetail" placeholder="请输入公司所在地详细地址"></el-input>
                    </el-form-item>
                    <el-form-item label="营业执照:" prop="zhuFile">
                         <el-upload
                            action="https://jsonplaceholder.typicode.com/posts/"
                            :file-list="ruleForm.zhuFile"
                            list-type="picture-card"
                            :on-change="handleChange1"
                            :auto-upload="false"
                            :on-preview="handlePictureCardPreview"
                            :limit="1"
                            :on-remove="handleRemove">
                              <i class="el-icon-plus"></i>
                        </el-upload>
                    </el-form-item>
                <el-form-item label="营业执照有效期:" prop='radio' message='请选择' class="time_radio" style="align-items: center;">
                    <el-radio   v-model="ruleForm.radio" label="1">
                        <el-date-picker :disabled="ruleForm.radio=='2'" v-model="ruleForm.time" type="daterange" range-separator="至" start-placeholder="开始日期"
                            end-placeholder="结束日期">
                    </el-date-picker></el-radio>
                    <el-radio v-model="ruleForm.radio" label="2">长期有效</el-radio>
                </el-form-item>
                     <el-form-item label="运营联系人:" prop="user">
                        <el-input style="width:35%" v-model="ruleForm.user" placeholder="请输入运营联系人姓名"></el-input>
                    </el-form-item>
                    <el-form-item label="运营人电话:" prop="phone">
                        <el-input style="width:35%" v-model="ruleForm.phone" placeholder="请输入手机号"></el-input>
                    </el-form-item>
                     <el-form-item label="邮箱:" prop="email">
                        <el-input style="width:35%" v-model="ruleForm.email" placeholder="请输入邮箱地址"></el-input>
                    </el-form-item>
                    <el-form-item label="平台推荐人：" prop="pepol">
                        <el-select v-model="ruleForm.pepol" placeholder="请选择">
                            <el-option v-for="(item,index) in tjPre" :key="index" :label="item.real_names" :value="item.id+','+item.real_names"></el-option>
                            <el-option label="无" value=""></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="店铺名称:" prop="shop_name">
                        <el-input  style="width:60%" v-model="ruleForm.shop_name" placeholder="请输入店铺名称" maxlength="40" show-word-limit></el-input>
                    </el-form-item>
                     <el-form-item label="统一信用代码:" prop="unified_credit_code">
                        <el-input  style="width:60%" v-model="ruleForm.unified_credit_code" placeholder="请输入统一信用代码"></el-input>
                    </el-form-item>
                    <el-form-item >
                        <el-button style="background:#E72F0D;width:237px;color:#fff;margin-top:20px;" :loading="disabled" @click="submitForm">注册</el-button>
                    </el-form-item>
                    </el-form>
            </div>
        </div>
    </div>
</template>
<script>
import {mapActions,mapGetters} from 'vuex'
import addressData from '../../../assets/js/area_data.json'
import RQ from '../../../assets/js/common'
export default {
    data(){
        return {
          ruleForm:{
             name:'',
             address:[],
             addressDetail:'',
             zhuFile:[],
             time:[],
             user:'',
             phone:'',
             email:'',
             pepol:'',
             shop_name:'',
             unified_credit_code:'',
             business_licenses_imgs_urls:'',
             radio:'1'
          },
          tjPre:[],
          disabled:false,
          options:addressData,
          befortime:[],
          lasttime:[],
          rules:{
              name: [
                    { required: true, message: '请输入公司名称', trigger: 'blur' },
                ],
                address:[
                     { required: true, message: '请选择公司所在地', trigger: 'blur' },
                ],
                addressDetail:[
                     { required: true, message: '请输入公司所在地详细地址', trigger: 'blur' },
                ],
                zhuFile:[
                    { required: true, message: '请上传营业执照'}
                ],
                radio:[
                     { required: true, message: '请选择营业执照有效期'}
                ],
                user:[
                    { required: true, message: '请输入运营联系人姓名'}
                ],
                phone:[
                     { required: true, message: '请输入手机号'}
                ],
                email:[
                     { required: true, message: '请输入邮箱地址', trigger: 'blur' },
                     { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
                ],
                pepol:[
                     { required: true, message: '请选择平台推荐人'}
                ],
                shop_name:[
                     { required: true, message: '请输入店铺名称'}
                ],
                unified_credit_code:[
                    { required: true, message: '请输入统一信用代码'}
                ]
          }
        }
    },
    computed:{
       ...mapGetters({
           userRegist:'product/getUserRegist',
           Regist:'getRegist'
       })
    },
    created(){
        console.log(this.userRegist,this.settleUser)
        this.Bind();
     if(this.Regist.phone!=''&&this.Regist.phone!=null){
            if(parseInt(this.Regist.reviewer_status)==2){
                this.getSettleUser({
                    reviewer_status:2,//审核状态
                    cellphones:this.Regist.phone
                }).then((res)=>{
                    if(res.code==1){
                        console.log(res)
                        this.ruleForm.name=res.data.company_name;
                        this.ruleForm.shop_name=res.data.shop_name;
                        this.ruleForm.unified_credit_code=res.data.unified_credit_code;
                        this.ruleForm.address=[res.data.address_provinces,res.data.address_citys,res.data.address_zones];//公司所在的省代码
                    this.ruleForm.addressDetail=res.data.address_managements;//详细地址
                    this.ruleForm.user=res.data.operator_name;//运营人姓名
                    this.ruleForm.phone=res.data.operator_cellphone;//运营人电话
                    this.ruleForm.email=res.data.email;//邮箱
                    this.ruleForm.business_licenses_imgs_urls=res.data.business_licenses_imgs;//营业执照仓库路径
                    this.ruleForm.zhuFile=[{url:res.data.business_licenses_imgs}];
                    if(res.data.business_licenses_time_start!=null&&res.data.business_licenses_time_start!=''){
                        this.ruleForm.radio='1';
                        this.befortime=[res.data.business_licenses_time_start,res.data.business_licenses_time_end];
                        this.ruleForm.time=[RQ.getRQ(res.data.business_licenses_time_start),RQ.getRQ(res.data.business_licenses_time_end)];
                        this.lasttime=[RQ.getRQ(res.data.business_licenses_time_start),RQ.getRQ(res.data.business_licenses_time_end)];
                        console.log(this.ruleForm.time)
                    }else{
                        this.ruleForm.radio='2';
                    }
                    }else{
                        this.$message.error(res.msg)
                    }
                })
            }
       }
			console.log(this.Regist.reviewer_status,'Regist')


    },
    mounted(){
    },
    methods:{
        ...mapActions({
          uploadBase64:'product/uploadBase64',
          buyerSettle:'product/buyerSettle',
          getSettleUser:'product/getSettleUser',
          updateSettle:'product/updateSettle',
          getRecommend:'product/getRecommend'
        }),
        Bind(){
           this.getRecommend().then((res)=>{
              console.log(res)
              if(res.code==1){
                  this.tjPre=res.data;
              }else{
                  this.$message.error(res.msg);
              }
           })
        },
        submitForm() {
            this.$refs["ruleForm"].validate((valid) => {
            if (valid) {
                    this.disabled=true;
                let data={
                    company_name:this.ruleForm.name,//公司名称
                    shop_name:this.ruleForm.shop_name,//店铺名称
                    unified_credit_code:this.ruleForm.unified_credit_code,//统一信用代码
                    address_provinces:this.ruleForm.address[0],//公司所在的省代码
                    address_citys:this.ruleForm.address[1],//公司所在的市代码
                    address_zones:this.ruleForm.address[2],//公司所在的区代码
                    address_managements:this.ruleForm.addressDetail,//详细地址
                    operator_name:this.ruleForm.user,//运营人姓名
                    operator_cellphone:this.ruleForm.phone,//运营人电话
                    email:this.ruleForm.email,//邮箱
                    business_licenses_imgs_urls:this.ruleForm.business_licenses_imgs_urls//营业执照仓库路径
                };
                if(this.ruleForm.pepol!=''){
                    data.referrer_id=this.ruleForm.pepol.split(',')[0];//推荐人id
                    data.referrer_name=this.ruleForm.pepol.split(',')[1];//推荐人姓名
                }
                if(this.ruleForm.radio=='1'){
                    if(this.ruleForm.time.length>1){
                        if(this.lasttime.length>0){
                            if(this.ruleForm.time==this.lasttime){
                                data.business_licenses_time_start=this.befortime[0];//营业执照有效期-开始时间
                                data.business_licenses_time_end=this.befortime[1];//营业执照有效期-开始时间
                            }
                        }else{
                            data.business_licenses_time_start=RQ.getSJC(this.ruleForm.time[0]);//营业执照有效期-开始时间
                            data.business_licenses_time_end=RQ.getSJC(this.ruleForm.time[1]);//营业执照有效期-开始时间
                        }
                    }else{
                            this.$message({
                            message: '请选择营业执照有效期',
                            type: 'warning'
                            });
                            this.disabled=false;
                        return;
                    }
                }
                if(this.Regist.phone!=''&&this.Regist.phone!=null&&parseInt(this.Regist.reviewer_status)==2){//编辑
                        data.cellphone=this.userRegist.cellphones;//手机号
                        data.is_register=1;//是否是注册修改，1-是注册修改
                        this.updateSettle(data).then((res)=>{
                            if(res.code==1){
                                    this.$message({
                                    message: '已为您提交申请！',
                                    type: 'success'
                                });
                                this.$router.push('/gologin')
                            }else{
                                this.$message.error(res.msg);
                            }
                        })
                }else{//注册
                    data.cellphones=this.userRegist.cellphones;//手机号
                    data.pwd1=this.userRegist.pass;//第一次输入的密码
                    data.pwd2=this.userRegist.pass;//第二次输入的密码
                        this.buyerSettle(data).then(res=>{
                            this.disabled=false;
                            if(res.code==1){
                                this.$message({
                                    message: '已为您提交申请！',
                                    type: 'success'
                                });
                                this.$router.push('/gologin')
                            }else{
                                this.$message.error(res.msg);
                            }
                        })
                }
            } else {
                console.log('error submit!!');
                return false;
            }
            });
        },
        handleChange1(file,fileList) {
            // var formdata=new FormData();
            // formdata.append("formdata",file);
            this.getBase64(file.raw).then(res=>{
                    this.uploadBase64({codes_base64:res.split(';base64,')[1],extensions:file.name.split('.')[1]}).then(res=>{
                            if(res.code==1){
                                this.ruleForm.business_licenses_imgs_urls=res.data.urls;
                                console.log( this.ruleForm.business_licenses_imgs_urls,'this.ruleForm.business_licenses_imgs_urls')
                            }else{
                                this.$message.error(res.msg);
                            }
                    })
            });     
            this.ruleForm.zhuFile=fileList.slice(-1);
        },
        getBase64(file) {
        return new Promise((resolve, reject) => {
            let reader = new FileReader();
            let fileResult = "";
            reader.readAsDataURL(file);
            //开始转
            reader.onload = function() {
            fileResult = reader.result;
            };
            //转 失败
            reader.onerror = function(error) {
            reject(error);
            };
            //转 结束  咱就 resolve 出去
            reader.onloadend = function() {
            // console.log(fileResult,'fileResult')
            resolve(fileResult);
            };
        });
        },
        handleRemove(file, fileList) {
        //console.log(file, fileList);
            this.ruleForm.zhuFile.splice(0,this.ruleForm.zhuFile.length);
            this.ruleForm.business_licenses_imgs_urls='';
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
    }

}
</script>
<style  lang='scss' scoped>
::v-deep .el-date-editor .el-range-separator{
    padding: 0;
}

.time_radio ::v-deep .is-checked .el-radio__inner{
  border-color: #e72f0d;
    background: #E72F0D
}
.main{
    background: #fff;
    margin: 25px;
}
.from{
    width:60%;
    margin: 0 auto;
    margin-top: 64px;
}
.main .title{
  color:#333333;
  padding: 22px;
  padding-left: 24px;
  border-bottom: 1px solid #D7DBE0;
}
.main{
    padding-bottom:50px;
}
.Settle{
  width:100%;
  display: flex;
  background: #F7F8FA;
  height: 100%;
}
.steps{
 height: 84px;
 display: flex;
 align-items: center;
 padding-left: 23%;
 box-sizing: border-box;
 background: #fff;
}
.steps p span.in{
  background: #E72F0D;
}
.steps p span{
   background: #CCCCCC;
   display: block;
   border-radius: 50%;
   overflow: hidden;
   font-size: 18px;
   color: #fff;
   text-align: center;
   width:36px;
   height: 36px;
   line-height: 36px;
   margin-right: 12px;
}
.steps .lin{
    display: block;
    width:14%;
    background: #E6E9ED;
    height: 3px;
    margin:0 12px;
}
.steps p{
    display: flex;
    align-items: center;
}
.steps p span i{
    font-size: 28px;
    line-height: 36px;
}
.login{
    font-size:16px;
    color: #333333;
    width: 100%;
    text-align: center;
}
.login .link{
    color: #E72F0D;
    font-size:16px;
    cursor: pointer;
}
.left{
  width:13.7%;
  background: #fff;
}
.text p:first-child{
  font-size: 16px;
  color:#333333;
  width: 100%;
  text-align: center;
}
.text p:last-child{
  font-size: 12px;
  color:#999999;
  width: 100%;
  text-align: center;
  margin-top: 9px;
  margin-bottom: 43px;
}
.logo{
    margin: 24px auto;
    width:42px;
    height: 42px;
    background: #ccc;
    border-radius: 50%;
    overflow: hidden;
    margin-bottom: 18px;
}
.right{
 width:86.3%;
}
</style>